import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from "js-cookie";
import Element from 'element-ui'
import './assets/styles/element-variables.scss'
// import { Message, MessageBox } from 'element-ui' // 添加这一行
import axios from "axios";
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.css';
import { downloadDevices, downloadDevicesUtf_8 } from '@/utils/request';
// 分页组件
import Pagination from "@/components/Pagination";
import 'vant/lib/index.css';
import "./assets/styles/index.css"; // global css
// 图片上传组件
import ImageUpload from "@/components/ImageUpload";
// 富文本组件
import Editor from "@/components/Editor";
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
import {
  parseTime,
  getDictName,
} from "@/utils/ruoyi";
import * as echarts from "echarts";
//将axios挂载到原型上
Vue.use(Vant);
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.prototype.parseTime = parseTime;
Vue.prototype.getDictName = getDictName;
Vue.prototype.downloadDevices = downloadDevices
Vue.prototype.downloadDevicesUtf_8 = downloadDevicesUtf_8
// Vue.prototype.Message = Message
// Vue.prototype.MessageBox = MessageBox
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
Vue.component("Pagination", Pagination);
Vue.component("ImageUpload", ImageUpload);
Vue.component("Editor", Editor);
Vue.component('ImagePreview', ImagePreview)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
